import React, { useState } from 'react';

import Sidebar from '../Sidebar/Sidebar';
import { HamburgerMenu } from '../Common';

interface Props {
  page: string;
  children: any;
}

function MobileWindow(props: Props) {
  const [sidebar, setSidebar] = useState(false);
  return (
    <>
      <div className="sidenav" style={{ width: sidebar ? '250px' : '0px' }}>
        <Sidebar page={props.page} mobile={true} />
      </div>
      <div
        className="mobile-window"
        id="main"
        style={{
          width: '100%',
          position: 'absolute',
          transform: sidebar ? 'translate(-250px)' : 'translate(0px)',
        }}
        onClick={() => (sidebar ? setSidebar(false) : null)}
      >
        <HamburgerMenu onClick={() => setSidebar(true)} />
        {props.children}
      </div>
    </>
  );
}

export default MobileWindow;
